(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('.watt-article__content--js');
  var tocList = document.querySelector('.watt-article__toc-list');
  if (!content || !tocList) return;

  var headings = content.querySelectorAll('h2, h3');
  if (!headings.length) {
    return;
  }

  var headingIdMap = new Map();

  headings.forEach(function (heading, index) {
    if (!heading.id) {
      heading.id = 'heading-' + (index + 1);
    }

    var li = document.createElement('li');
    li.className = 'watt-article__toc-item watt-article__toc-item--' + heading.tagName.toLowerCase();

    var a = document.createElement('a');
    a.className = 'watt-article__toc-link';
    a.href = '#' + heading.id;
    a.textContent = heading.textContent.trim();

    li.appendChild(a);
    tocList.appendChild(li);

    headingIdMap.set(heading, a);
  });

  if ('IntersectionObserver' in window) {
    var activeLink = null;

    var observer = new IntersectionObserver(
      function (entries) {
        var visibleHeadings = entries
          .filter(function (entry) { return entry.isIntersecting; })
          .sort(function (a, b) { return a.target.offsetTop - b.target.offsetTop; });

        if (!visibleHeadings.length) return;

        var topMost = visibleHeadings[0].target;
        var link = headingIdMap.get(topMost);
        if (!link || link === activeLink) return;

        if (activeLink) {
          activeLink.classList.remove('watt-article__toc-link--active');
        }
        link.classList.add('watt-article__toc-link--active');
        activeLink = link;
      },
      {
        root: null,
        rootMargin: '0px 0px -80% 0px',
        threshold: 0.1
      }
    );
    headings.forEach(function (heading) { observer.observe(heading); });
  }


  // 推荐文章
  if(window.wattcycle) {
    window.wattcycle.loadSplide().then(function() {
        var splide = new Splide('.watt-article__rec-splide', {
            pagination: true,
            arrows: false,
            type: 'loop',
            drag: true,
            perPage: 4,
            autoplay: true,
            resetProgress: false,
            breakpoints: {
                900: {
                    perPage: 3,
                }
            },
            classes: {
                page: 'watt-article__rec-pgn-item',
            },
        })
        window.wattcycle.setSplideProgress(splide)
        splide.mount()
    })
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function () {
    const cartRoot = document.querySelector('.watt-cart__wrap');
    if (cartRoot) {
      if(window.wattcycle) {
        window.wattcycle.initWattCart(cartRoot);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var filterButton = document.querySelector('.watt-collection__filter');
  var filterDom = document.querySelector('#watt-collection-filter')
  let filterHtml = '';
  if (filterDom) {
    filterHtml = filterDom.innerHTML;
  }
  filterButton.addEventListener('click', function () {
      if(window.wattPushbar) {
        window.wattPushbar.open('left', filterHtml)
      }
      var filterForm = document.querySelector('.watt-collection__filters-form');
      if (filterForm) {
        var filterInputs = filterForm.querySelectorAll('input[type="checkbox"], input[type="number"]');
        filterInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            filterForm.submit();
          });
        });
      }
  });

  var sortForm = document.querySelector('.watt-collection__sort');
  if (sortForm) {
    var sortSelect = sortForm.querySelector('#sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortForm.submit();
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get('video-component')) {
    class Video extends HTMLElement {
      constructor() {
        super();
        this.autoplay = this.dataset.autoplay === 'true';
        this.background = this.dataset.background === 'true';
        this.naturalWidth = this.dataset.naturalWidth === 'true';
      }

      connectedCallback() {
        this.init();
      }

      init() {
        const url = this.dataset.videoUrl;

        if (url) {
          if (url.includes('youtu.be') || url.includes('youtube.com')) {
            if (url.includes('v=')) {
              this.videoId = url.split('v=').pop().split('&')[0];
            } else {
              this.videoId = url.split('?')[0].split('/').pop();
            }

            // parse start time from common YouTube params (t= or start=)
            let start = null;
            if (url.includes('t=')) {
              start = url.split('t=').pop().split('&')[0];
            } else if (url.includes('start=')) {
              start = url.split('start=').pop().split('&')[0];
            }
            if (start) {
              // handle values like 4s or plain seconds
              if (start.endsWith && start.endsWith('s')) start = start.slice(0, -1);
              const s = parseInt(start, 10);
              if (!Number.isNaN(s)) this.startSeconds = s;
            }

            this.type = 'youtube';
            this.initYouTube();
          } else if (url.includes('vimeo.com')) {
            this.videoId = url.split('?')[0].split('/').pop();
            this.type = 'vimeo';
            this.initVimeo();
          }
        } else {
          this.type = 'tag';
          this.initVideoTag();
        }

        // Allow for videos which haven't played to play on tap
        if (this.background) {
          const rootItem = this.closest('.video-item');
          if (rootItem) rootItem.addEventListener('click', this.play.bind(this));
        }
      }

      /**
       * Loads a player API script.
       * @param {string} src - Url of script to load.
       */
      loadScript(src) {
        if (document.querySelector(`script[src="${src}"]`)) return;

        const s = document.createElement('script');
        s.src = src;
        s.onerror = (err) => console.warn(`Unable to load script ${src}`, err); // eslint-disable-line

        if (this.type === 'vimeo') {
          s.onload = () => document.dispatchEvent(new CustomEvent('on:vimeo-api:loaded'));
        } else if (this.type === 'youtube') {
          window.onYouTubeIframeAPIReady = () => document.dispatchEvent(new CustomEvent('on:youtube-api:loaded'));
        }

        document.body.appendChild(s);
      }

      /**
       * Initialises a YouTube video.
       */
      initYouTube() {
        const initYTPlayer = () => {
          YT.ready(() => {
            this.player = new YT.Player(this.querySelector('div'), {
              videoId: this.videoId,
              width: '1280',
              height: '720',
              playerVars: function() {
                const p = {
                  controls: this.background ? 0 : 1,
                  disablekb: this.background ? 1 : 0,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  playsinline: 1,
                  rel: 0,
                };
                if (this.startSeconds) p.start = this.startSeconds;
                return p;
              }.call(this),
              events: {
                onReady: this.handleYTReady.bind(this),
                onStateChange: this.handleYTStateChange.bind(this),
              },
            });
          });
        };

        if (!window.YT) {
          document.addEventListener('on:youtube-api:loaded', initYTPlayer.bind(this));
          this.loadScript('//www.youtube.com/iframe_api');
        } else {
          initYTPlayer();
        }
      }

      /**
       * Initialises a Vimeo video.
       */
      initVimeo() {
        const initVimeoPlayer = async () => {
          this.player = new Vimeo.Player(this, {
            id: this.videoId,
            width: '1280',
            height: '720',
            autoplay: this.autoplay,
            background: this.background,
            keyboard: !this.background,
            muted: this.autoplay,
          });

          await this.player.ready();
          this.setupIframe('js-vimeo');

          this.player.on('pause', () => {
            if (this.inViewport) this.pausedByUser = true;
          });

          this.player.on('play', () => {
            const rootItem = this.closest('.video-item');
            if (rootItem) rootItem.classList.add('video-item--played');
          });

          this.play();
        };

        if (!window.Vimeo) {
          document.addEventListener('on:vimeo-api:loaded', initVimeoPlayer.bind(this));
          this.loadScript('//player.vimeo.com/api/player.js');
        } else {
          initVimeoPlayer();
        }
      }

      /**
       * Initialises a video tag.
       */
      initVideoTag() {
        this.player = this.querySelector('video');

        this.player.addEventListener('pause', () => {
          if (this.inViewport) this.pausedByUser = true;
        });

        // If the video is already playing
        if (
          this.player.currentTime > 0 &&
          !this.player.paused &&
          !this.player.ended &&
          this.player.readyState > 2
        ) {
          const rootItem = this.closest('.video-item');
          if (rootItem) rootItem.classList.add('video-item--played');
        } else {
          this.player.addEventListener('play', () => {
            const rootItem = this.closest('.video-item');
            if (rootItem) rootItem.classList.add('video-item--played');
          });

          this.addObserver(this.player);

          // Mute the video if a click didn't trigger its load
          const deferredMedia = this.closest('deferred-media');
          if (!deferredMedia || deferredMedia.loadTrigger !== 'click') {
            this.player.muted = true;
          }

          this.play();
        }
      }

      /**
       * Handles a YouTube ready event.
       */
      handleYTReady() {
        this.setupIframe('js-youtube');

        if (this.autoplay) this.player.mute();
        this.play();
      }

      /**
       * Handles a YouTube state change event.
       * @param {object} e - Event object.
       */
      handleYTStateChange(e) {
        if (e.data === YT.PlayerState.PAUSED) {
          if (this.inViewport) this.pausedByUser = true;
        } else if (e.data === YT.PlayerState.ENDED) {
          // Looping this way rather than 'loop' API parameter to avoid flash of black background
          if (this.background) this.player.playVideo();
        } else if (e.data === YT.PlayerState.PLAYING) {
          const rootItem = this.closest('.video-item');
          if (rootItem) rootItem.classList.add('video-item--played');
        }
      }

      /**
       * Sets up the injected iframe.
       * @param {string} jsClass - Class name to add to the iframe.
       */
      setupIframe(jsClass) {
        // Enable iframe to cover entire container height.
        if (this.autoplay && !this.naturalWidth) {
          this.style.width = `${this.clientHeight * 1.7778}px`;

          window.addEventListener(
            'resize',
            window.debounce(() => {
              this.style.width = `${this.clientHeight * 1.7778}px`;
            }, 200)
          );
        }

        this.iframe = this.querySelector('iframe');
        this.iframe.title = this.dataset.description;
        this.iframe.classList.add(jsClass);
        this.addObserver(this.iframe);
      }

      /**
       * Plays the video when scrolled into view (if not paused by the user).
       */
      play() {
        if (!this.player || this.pausedByUser) return;

        if (this.type === 'youtube') {
          this.player.playVideo();
        } else {
          this.player.play();
        }
        try {
          document.dispatchEvent(new CustomEvent('vv:playing', {
            detail: {
              component: this
            }
          }));
        } catch (e) {
          // ignore
        }
      }

      /**
       * Pauses the video when scrolled out of view (if playing).
       */
      pause() {
        if (!this.player) return;

        if (this.type === 'youtube') {
          if (this.player.getPlayerState() !== 2) {
            this.player.pauseVideo();
            this.pausedByUser = false;
            try {
              document.dispatchEvent(new CustomEvent('vv:paused', {
                detail: {
                  component: this
                }
              }));
            } catch (e) {}
          }
        } else if (this.type === 'vimeo') {
          this.player.getPaused().then((paused) => {
            if (!paused) {
              this.player.pause();
              this.pausedByUser = false;
              try {
                document.dispatchEvent(new CustomEvent('vv:paused', {
                  detail: {
                    component: this
                  }
                }));
              } catch (e) {}
            }
          });
        } else if (!this.player.paused) {
          this.player.pause();
          this.pausedByUser = false;
          try {
            document.dispatchEvent(new CustomEvent('vv:paused', {
              detail: {
                component: this
              }
            }));
          } catch (e) {}
        }
      }

      /**
       * Adds an observer to pause the video when not in the viewport.
       * @param {Element} el - Element to observe.
       */
      addObserver(el) {
        if ('IntersectionObserver' in window === false) return;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(
            (entry) => {
              if (entry.isIntersecting) {
                this.inViewport = true;
                this.play();
              } else {
                this.inViewport = false;
                this.pause();
              }
            }, {
              rootMargin: '0px 0px 200px 0px'
            }
          );
        });

        observer.observe(el);
      }
    }

    customElements.define('video-component', Video);
  }

  let currentPage = 1;
  const itemsPerPage = 6;
  const allItems = Array.from(document.querySelectorAll('.video-item'));
  let filteredItems = allItems.slice();

  function showPage(page) {
    // Show items cumulatively up to the requested page (do not hide previously revealed items)
    // Hide all first, then unhide items with index < page * itemsPerPage
    allItems.forEach((el) => (el.style.display = 'none'));

    const end = page * itemsPerPage;

    filteredItems.forEach((el, idx) => {
      if (idx < end) {
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    });

    updateViewMoreVisibility();
  }

  function updateViewMoreVisibility() {
    const viewMoreBtn = document.querySelector('.view-more');
    if (!viewMoreBtn) return;
    const totalPages = Math.ceil(filteredItems.length / itemsPerPage) || 1;
    if (currentPage >= totalPages) {
      viewMoreBtn.style.display = 'none';
    } else {
      viewMoreBtn.style.display = '';
    }
  }

  // 初始显示第一页
  showPage(currentPage);

  // 添加分页按钮逻辑（可选）
  const viewMore = document.querySelector('.view-more');
  if (viewMore) {
    viewMore.addEventListener('click', () => {
      const totalPages = Math.ceil(filteredItems.length / itemsPerPage) || 1;
      if (currentPage < totalPages) {
        currentPage++;
        showPage(currentPage);
      }
      updateViewMoreVisibility();
    });
  }

  const tagFilters = Array.from(document.querySelectorAll('.tag-filter'));

  // Tag Filtering
  tagFilters.forEach((filter) => {
    filter.addEventListener('click', function () {
      const selectedTag = this.getAttribute('data-tag');

      // Remove active state from all buttons
      tagFilters.forEach((f) => f.classList.remove('active'));
      this.classList.add('active');

      // Update filteredItems based on selected tag
      if (selectedTag === 'all') {
        filteredItems = allItems.slice();
      } else {
        filteredItems = allItems.filter((item) => {
          const itemTags = item.getAttribute('data-tags') || '';
          return itemTags.split(' ').includes(selectedTag);
        });
      }

      // Reset to first page and show
      currentPage = 1;
      showPage(currentPage);
    });
  });

  // Delegated click to load deferred-media content and start playback
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.js-load-media');
    if (!btn) return;

    const deferred = btn.closest && btn.closest('deferred-media');
    if (!deferred) return;

    // Load template into deferred if not already
    if (!deferred.hasAttribute('data-loaded')) {
      const tpl = deferred.querySelector('template');
      if (tpl) {
        deferred.insertAdjacentHTML('beforeend', tpl.innerHTML);
        deferred.setAttribute('data-loaded', 'true');
      }
    }

    const vc = deferred.querySelector('video-component');
    if (!vc) return;

    const root = btn.closest && btn.closest('.video-item');
    if (root) root.classList.add('video-item--loading');

    // Poll until the player instance or video element is ready, then call play()
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const nativeVideo = vc.querySelector && vc.querySelector('video');
      const ready = vc.player || (nativeVideo && nativeVideo.readyState > 2);
      if (ready) {
        try {
          if (typeof vc.play === 'function') vc.play();
        } catch (err) {}
        if (root) {
          root.classList.remove('video-item--loading');
          root.classList.add('video-item--played');
        }
        clearInterval(interval);
      } else if (attempts > 25) {
        clearInterval(interval);
        if (root) root.classList.remove('video-item--loading');
      }
    }, 200);
  });

  // Pause other players when one starts playing
  document.addEventListener('vv:playing', (e) => {
    const playingComponent = e && e.detail && e.detail.component;
    if (!playingComponent) return;
    document.querySelectorAll('video-component').forEach((v) => {
      if (v !== playingComponent && typeof v.pause === 'function') {
        try {
          v.pause();
        } catch (err) {}
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const navActiveName = 'watt-footer__top-item--active'
    const navItemsClass = '.watt-footer__top-nav'
    const navItems = document.querySelectorAll(navItemsClass);
    const navBoxItems = document.querySelectorAll('.watt-footer__top-item')
    document.querySelectorAll('.watt-footer__top-item').forEach(item => {
      const nav = item.querySelector(navItemsClass);
      item.addEventListener('click', () => {
        if (window.innerWidth > 900) {
          reset();
          return;
        }
        const isActive = item.classList.toggle(navActiveName);
        if (isActive) {
          nav.style.height = '0px';
          nav.offsetHeight;
          nav.style.height = nav.scrollHeight + 'px';
        } else {
          nav.style.height = '0px';
        }
      });
    });

    function reset() {
      const isDesktop = window.innerWidth > 900;
      navItems.forEach(nav => {
        nav.style.height = isDesktop
          ? 'auto'
          : '0px';
      });
      navBoxItems.forEach(item => {
        item.classList.remove(navActiveName);
      });
    }
    window.addEventListener('resize', reset, {passive: true});

    if(window.wattcycle) {
      const gotop = document.querySelector('.watt-gotop');
      function toggleGotop() {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrollPercent >= 5) {
          gotop.style.display = 'flex';
        } else {
          gotop.style.display = 'none';
        }
      }
      const throttledToggleGotop = window.wattcycle.throttle(toggleGotop);
      window.addEventListener('scroll', throttledToggleGotop, { passive: true });
      gotop.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // 处理 normal_menu 类型的 mega menu，添加相对定位类
    const megaList = document.querySelectorAll('[data-menu-type="normal_menu"]')
    if(megaList.length > 0) {
      megaList.forEach(mega => {
        const menuType = mega.dataset.menuType
        const parentDom = mega.closest('.watt-header__menu-item')
        if(parentDom) {
          parentDom.classList.add('watt-header__menu--relative')
        }
      })
    }

    if(window.wattcycle) {
      window.wattcycle.loadSplide().then(function() {
          var splideItems = document.querySelectorAll('.watt-header__topbar .watt-header__topbar-list-item')
          if(splideItems.length > 1) {
            (new Splide('.watt-header__topbar', {
              type: 'loop',
              arrows: true,
              pagination: false,
              focus: 'center',
              perPage: 1,
              autoplay: true,
            })).mount();
            var navDom = document.querySelector('.watt-header__topbar-nav')
            if(navDom) {
              navDom.style.display = 'flex';
            }
          }
      })
      window.wattcycle.loadA11yTabs().then(function() {
          const tab = document.querySelector('.watt-header__menu-mega--tab')
          if(tab) {
            new A11yTabs(".watt-header__menu-mega--tab", '.watt-header__menu-mega-wrap [role="tabpanel"]', 0);
            const doms = document.querySelectorAll('.watt-header__menu-mega--tab button')
            // hover时自动切换超级菜单menu
            doms.forEach(element => {
              element.addEventListener('mouseenter', () => {
                element.click();
              });
            });
          }
      })
    }

    // 初始化搜索推荐轮播产品卡片
    function initRecBottomSplide() {
        const splideEl = document.querySelector('.watt-predsearch__rec-bottom-splide')
        if(!splideEl) return
        if (window.wattcycle) {
          window.wattcycle.loadSplide().then(function () {
            var splide = new Splide(splideEl, {
              pagination: false,
              arrows: true,
              drag: true,
              snap: true,
              perPage: 5,
              gap: '1.25em',
              lazyLoad: 'nearby',
              breakpoints: {
                900: {
                  perPage: 3,
                  gap: '1.875em',
                },
              },
            });
            splide.mount();
          });
        }
        const predRecEl = document.querySelector('.watt-predsearch__rec')
        // 监听“有值”事件
        document.addEventListener('pred-search-has-value', () => {
          predRecEl.style.display = 'none'
        });
        // 监听“无值”事件
        document.addEventListener('pred-search-is-empty', () => {
            predRecEl.style.display = 'block'
        });
    }

    

    const searchBtn = document.querySelector('.watt-header__widget-search')
    searchBtn.addEventListener('click', function() {
      if(window.wattPushbar) {
        var searchDom = document.querySelector('#watt-predsearch__template')
        var copySearchDom = searchDom.content.cloneNode(true)
        window.wattPushbar.open('top', copySearchDom)
        initRecBottomSplide()
      }
    })

    const mMenutmpDom = document.querySelector('#watt-global-mmenu')
    const mMenuBtn = document.querySelector('.watt-header__widget-menu')
    let mMenuHtml = '';
    if (mMenutmpDom) {
      mMenuHtml = mMenutmpDom.innerHTML;
    }
    mMenuBtn.addEventListener('click', function() {
      if(window.wattPushbar) {
        window.wattPushbar.open('left', mMenuHtml)
        window.wattcycle.accordion(".watt-mmenu__expend", { panelSelector: '.watt-mmenu__panel', accordionItemSelector: '.watt-mmenu' });
        window.wattcycle.accordion(".watt-mmenu__btn", { panelSelector: '.watt-mmenu__panel', accordionItemSelector: '.watt-mmenu' });
        const iconDoms = document.querySelectorAll('.watt-mmenu__mega-info-icon-item')
        if(iconDoms && iconDoms.length > 0) {
          iconDoms.forEach(item => {
            item.addEventListener('click', (e) => {
              e.stopPropagation();
              e.preventDefault();
            })
          })
        }
      }
    })

    const openCartBtn = document.querySelector('[data-side-cart-btn]');
    if (openCartBtn) {
      openCartBtn.addEventListener('click', () => {
        // 计算 cart 页面的标准路径
        const cartPath =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.cart_url) ||
          '/cart';

        // 去掉路径尾部多余的斜杠，避免 "/cart" 和 "/cart/" 不相等
        const normalizePath = (path) =>
          typeof path === 'string' ? path.replace(/\/+$/, '') : path;

        const currentPath = normalizePath(window.location.pathname);
        const targetCartPath = normalizePath(cartPath);

        // 如果当前就是购物车页面，则不打开抽屉，直接返回
        if (currentPath === targetCartPath) {
          window.location.href = cartPath;
          return;
        }

        if (!window.wattcycle) return;

        window.wattcycle.setLoading(openCartBtn, true);

        window.wattcycle
          .fetchCartView()
          .then((html) => {
            window.wattcycle.openSideCart(html);
          })
          .catch((error) => {
            console.error('打开购物车失败:', error);
            window.location.href = cartPath;
          })
          .finally(() => {
            window.wattcycle.setLoading(openCartBtn, false);
          });
      });
    }


   // header滚动悬停效果
  const main = document.querySelector('.watt-main')
  const headerBox = document.querySelector('.watt-header');
  const topbar = document.querySelector('.watt-header__topbar');
  const mainMenu = document.querySelector('.watt-header__fixedbox');
  const cdtm = document.querySelector('.watt-header__cdtm');
  // 安全检查：如果关键元素不存在，直接退出，防止报错
  if (!headerBox || !topbar || !mainMenu) return;
  let lastScrollTop = 0;
  let triggerHeight = headerBox.offsetHeight * 3.5;
  let topThreshold = topbar.offsetHeight
  // 更新阈值函数
  const updateThresholds = () => {
      triggerHeight = headerBox.offsetHeight * 3.5;
      topThreshold = topbar.offsetHeight
      if(cdtm) {
        const cdtmHeight = cdtm.offsetHeight
        topThreshold = topbar.offsetHeight + cdtmHeight
        let otherHeightRes = cdtmHeight 
        document.documentElement.style.setProperty('--watt-other-height', otherHeightRes + 'px');
      }
  };
  window.addEventListener('resize', updateThresholds);
  document.addEventListener('header-height-changed', updateThresholds);
  // 使用 requestAnimationFrame 优化滚动性能，避免高频重绘
  let ticking = false;
  
  window.addEventListener('scroll', () => {
      if (!ticking) {
          window.requestAnimationFrame(() => {
              handleScroll();
              ticking = false;
          });
          ticking = true;
      }
  });
  function handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      // 确定当前需要的状态类名
      let shouldHaveActive = false;
      let shouldHaveTop = false;
      // 逻辑分区
      if (currentScroll <= topThreshold) {
          // 区域 1: 顶部 (滚动距离 <= Topbar 高度)
          // 行为: 取消 fixed (恢复 relative), 显示在文档流中
          shouldHaveTop = true;
          shouldHaveActive = false; 
      } else if (currentScroll > triggerHeight) {
          // 区域 3: 深层滚动 (超过阈值)
          // 行为: 智能显示/隐藏 (Fixed 定位)
          shouldHaveTop = false;
          // 上滚显示，下滚隐藏
          if (currentScroll < lastScrollTop) {
              shouldHaveActive = true;
          } else {
              shouldHaveActive = false;
          }
      } else {
          // 区域 2: 中间过渡区 (Topbar 高度 < 滚动距离 <= 阈值)
          // 行为: 保持 Fixed 且显示，防止突然消失
          shouldHaveTop = false;
          shouldHaveActive = true;
      }
      
      if (shouldHaveActive) {
          mainMenu.classList.add('watt-header__fixedbox--active');
          main.classList.add('watt-hdfixed-mark')
      } else {
          mainMenu.classList.remove('watt-header__fixedbox--active');
          main.classList.remove('watt-hdfixed-mark')
      }
      if (shouldHaveTop) {
          mainMenu.classList.add('watt-header__fixedbox--top');
      } else {
          mainMenu.classList.remove('watt-header__fixedbox--top');
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }
  // 初始化运行一次，防止页面加载时已有滚动条导致样式错误
  handleScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-applications-section"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.watt-home__applications');

  if (!sections.length) return;

  sections.forEach(function (section) {
    const elements = section.querySelectorAll('.watt-home__applications-item');
    if (elements.length) {
      let activeIndex = 0;
      const activeName = 'watt-active'
      function updateAccordion() {
        elements.forEach(function (el, index) {
          if (index === activeIndex) {
            el.classList.add(activeName);
          } else {
            el.classList.remove(activeName);
          }
        });
      }

      updateAccordion();

      elements.forEach(function (el, index) {
        el.addEventListener('mouseenter', function () {
          if (index !== activeIndex) {
            activeIndex = index;
            updateAccordion();
          }
        });
      });
    }

    if (!window.wattcycle) return

    window.wattcycle
      .loadSplide()
      .then(function () {
        return window.wattcycle.loadSplideExtensions();
      })
      .then(function () {
        const splideElements = section.querySelectorAll('.watt-home__applications-splide');

        splideElements.forEach(function (splideEl) {
          const splide = new Splide(splideEl, {
            type: 'splide',
            arrows: false,
            pagination: false,
            drag: 'free',
            autoScroll: false,
            destroy: true,
            breakpoints: {
              900: {
                type: 'loop',
                destroy: false,
                autoScroll: {
                  speed: 0.5
                }
              }
            }
          });
          splide.mount(window.splide.Extensions);
        });
      })
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if(window.wattcycle) {
      window.wattcycle.loadSplide().then(function() {
          document.querySelectorAll('.watt-home__banner').forEach((element, index) => {
            const splide = new Splide(element, {
                  pagination: true,
                  arrows: true,
                  focus  : 'center',
                  type: 'loop',
                  autoplay: true,
                  resetProgress: false,
                  classes: {
                    page: 'watt-home__banner-pgn-item',
                  }
              });
            splide.mount();
            window.wattcycle.setSplideProgress(splide)
          });
      })
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-blog-section"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function () {
    if (window.wattcycle) {
        window.wattcycle.loadSplide().then(function () {
            // 获取页面中所有匹配的轮播图容器
            var splideElements = document.querySelectorAll('.watt-home__blog-splide');
            
            // 遍历每个容器，进行独立的初始化
            splideElements.forEach(function (element) {
                const autoplay = element.dataset.wattAutoplay === 'true';
                const type = autoplay ? 'loop' : 'slide';

                var splide = new Splide(element, { // 直接传入 DOM 元素，而非字符串选择器
                    pagination: true,
                    arrows: false,
                    type: type,
                    drag: true,
                    perPage: 3,
                    autoplay: autoplay,
                    resetProgress: false,
                    breakpoints: {
                        900: {
                            perPage: 1,
                        }
                    },
                    classes: {
                        page: 'watt-home__blog-pgn-item',
                    },
                });
                if(autoplay) {
                    window.wattcycle.setSplideProgress(splide);
                }
                // 为每个实例单独绑定进度条逻辑
                splide.mount();
            });

            // 图片懒加载（通常只需执行一次，针对整个列表区域）
            window.wattcycle.dynLoadImagesFn('.watt-home__blog-list');
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-experts-section"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function () {
    if (window.wattcycle) {
        window.wattcycle.loadSplide().then(function () {
            // 1. 获取页面中所有匹配的轮播图容器
            var splideElements = document.querySelectorAll('.watt-home__experts-splide');
            
            // 2. 遍历每个容器，进行独立的初始化
            splideElements.forEach(function (element) {
                const autoplay = element.dataset.wattAutoplay === 'true';
                const type = autoplay ? 'loop' : 'slide';
                var splide = new Splide(element, { // 直接传入 DOM 元素，而非字符串选择器
                    pagination: true,
                    arrows: false,
                    type: type,
                    drag: true,
                    perPage: 3,
                    autoplay: autoplay,
                    resetProgress: false,
                    breakpoints: {
                        900: {
                            perPage: 1,
                        }
                    },
                    classes: {
                        page: 'watt-home__experts-pgn-item',
                    },
                });
                if(autoplay) {
                    // 3. 为每个实例单独绑定进度条逻辑并挂载
                    window.wattcycle.setSplideProgress(splide);
                }

                splide.mount();
            });
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-outdoor-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    if (window.wattcycle) {
        window.wattcycle.loadSplide().then(function () {
            const splideElements = document.querySelectorAll('.watt-home__outdoor-splide');
            splideElements.forEach(function (el) {
                new Splide(el, {
                    pagination: true,
                    arrows: false,
                    type: 'slide',
                    drag: 'free',
                    perPage: 3,
                    breakpoints: {
                        900: {
                            perPage: 1,
                        }
                    },
                    classes: {
                        page: 'watt-home__outdoor-pgn-item',
                    },
                }).mount();
            });
        });
        window.wattcycle.dynLoadImagesFn('.watt-home__outdoor-wrap');
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-products-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    if(window.wattcycle) {
      window.wattcycle.loadSplide().then(function() {
      document.querySelectorAll('.watt-home__products-splide').forEach(function (splide) {
        (new Splide(splide, {
            pagination: true,
            arrows: true,
            type: 'slide',
            drag: 'free',
            perPage: 3,
            breakpoints: {
                900: {
                    perPage: 1,
                }
            },
            classes: {
                page: 'watt-home__products-pgn-item',
            },
        })).mount()
      })
      })
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-review-section"] && !Shopify.designMode) return;
  try {
    
function initWattreviewSection(container) {
  if (!window.wattcycle) return;
  var splideElement = container.querySelector('.watt-home__review-splide');
  if (!splideElement) return;
  window.wattcycle
    .loadSplide()
    .then(function () {
      return window.wattcycle.loadSplideExtensions();
    })
    .then(function () {
      var splide = new Splide(splideElement, {
        type: 'loop',
        arrows: false,
        pagination: false,
        drag: 'free',
        autoScroll: {
          speed: 0.5
        }
      }).mount(window.splide.Extensions);
    }).catch(function (error) {
      console.error('Failed to initialize watt home review Splide', error);
    });
}

document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.watt-home__review');
  sections.forEach(function (section) {
    initWattreviewSection(section);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-series-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    if(window.wattcycle) {
        window.wattcycle.loadSplide().then(function() {
            var splide = new Splide( '.watt-home__series-splide', {
                pagination: false,
                arrows: false,
                type: 'slide',
                drag: true,
                destroy: true,
                breakpoints: {
                    900: {
                        destroy: false,
                    }
                }
            })
            var bar = splide.root.querySelector('.watt-home__series-splide-progress'); 
            splide.on( 'mounted moved resize', function () {
                var end  = splide.Components.Controller.getEnd() + 1;
                var rate = Math.min( ( splide.index + 1 ) / end, 1 );
                bar.style.setProperty('--progress', `${rate * 100}%`);
            });
            splide.mount()
        })
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-service-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    function dynLoadImagesFn() {
        const doms = document.querySelectorAll('[data-watt-style]');
        if (doms.length === 0) return;
        const handleScroll = () => {
            doms.forEach(dom => {
                const style = dom.getAttribute('data-watt-style');
                if (style) {
                    dom.style.cssText = style;
                    dom.removeAttribute('data-watt-style'); 
                }
            });
            window.removeEventListener('scroll', handleScroll);
        };
        window.addEventListener('scroll', handleScroll);
    }
    dynLoadImagesFn();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-value-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (window.wattcycle) {
      window.wattcycle.loadSplide().then(function() {
        window.wattcycle.loadSplideExtensions().then(function() {
          document.querySelectorAll('.watt-home__value-splide').forEach((element, index) => {
            (new Splide(element, {
              type: 'slide',
              arrows: false,
              pagination: false,
              focus: 'start',
              perPage: 4,
              autoScroll: false,
              destroy: true,
              breakpoints: {
                900: {
                  perPage: 1,
                  type: 'loop',
                  destroy: false,
                  autoScroll: {
                    speed: 0.5
                  }
                }
              }
            })).mount(window.splide.Extensions);
          });
        })
      })
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-youtube-section"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', function () {
        // 2. 安全检查：确保模态框对象存在
        let hasModal = true
        if (!window.wattcycle_modal || typeof window.wattcycle_modal.open !== 'function') {
            console.warn('wattcycle_modal is not available.');
            hasModal = false
            return;
        }

        function initClickOpenVideoModal(container) {
            if(container && container.addEventListener) {
                container.addEventListener('click', function (e) {
                    const item = e.target.closest('.watt-home__youtube-item');
                    if (item && container.contains(item)) {
                        const template = item.querySelector('template');
                        if (template) {
                            e.stopPropagation();
                            const domNode = template.content.cloneNode(true);
                            // 3. 传入 DOM 节点而不是 HTML 字符串
                            window.wattcycle_modal.open(domNode);
                        } else {
                            console.warn('No template found in clicked item:', item);
                        }
                    }
                });
            }
        }

        function initWattreviewSection(container) {
            if (!window.wattcycle) return;
            var splideElement = container.querySelector('.watt-home__youtube-splide');
            if (!splideElement) return;
            window.wattcycle.loadSplide().then(function () {
                    return window.wattcycle.loadSplideExtensions();
            }).then(function () {
                var splide = new Splide(splideElement, {
                    type: 'loop',
                    arrows: false,
                    pagination: false,
                    drag: 'free',
                    autoScroll: {
                        speed: 0.5
                    }
                }).mount(window.splide.Extensions);
                window.wattcycle.dynLoadImagesFn('.watt-home__youtube-list');
            })
        }
        
        var sections = document.querySelectorAll('.watt-home__youtube');
        sections.forEach(function (section) {
            initWattreviewSection(section);
            if(hasModal) {
                initClickOpenVideoModal(section)
            }
        });
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const root = document.querySelector('.watt-prod')
  if(!root) return
  const selectEl = root.querySelector('.watt-prod__buybar-var');
  const buybar = root.querySelector('.watt-prod__buybar');

  let mainSplide = null
  if (window.wattcycle) {
    window.wattcycle.initShoppingOperation(root)
    const thub = root.querySelector('.watt-prod__cover-thub')
    let thubSize = thub.getAttribute('data-splide-size') * 1
    let direction = thubSize >= 5 ? 'center' : false
    window.wattcycle.loadSplide().then(function() {
      mainSplide = new Splide('.watt-prod__cover-main', {
        pagination: false,
        arrows: true,
        focus: 'center',
        autoplay: false,
        resetProgress: false,
        cover: true,
      });
      var thubSplide = new Splide('.watt-prod__cover-thub', {
        rewind: true,
        pagination: false,
        arrows: true,
        isNavigation: true,
        focus: direction,
        dragMinThreshold: {
          mouse: 4,
          touch: 10,
        },
      });
      mainSplide.sync(thubSplide);
      mainSplide.mount();
      thubSplide.mount();
    })
    const otherBtn = root.querySelector('.watt-prod__other-btn')
    if(otherBtn) {
        window.wattcycle.accordion('.watt-prod__other-btn');
    }
  }

// ------------------------------------------------------------
// buybar变体切换
if (selectEl) {
  selectEl.addEventListener('change', e => {
    document.dispatchEvent(new CustomEvent('watt:prod:var:id:change', {
        detail: {
            selectedData: e.target.value,
            root, 
        }
    }))
  })
}

// ------------------------------------------------------------
// 设置购买栏选择的变体
function setBarSelectedVariant(selectedVariant, selectEl) {
    if(selectedVariant && selectEl) {
        selectEl.value = selectedVariant.id
    }
}
// 设置主图片
function setMainProdImage(selectedVariant, mainSplide) {
    if(!selectedVariant) return
    const variantImageId = selectedVariant?.featured_image?.id || null
    if (variantImageId && mainSplide) {
        const slides = mainSplide.Components.Slides.get();
        let targetIndex = null;
        slides.forEach((slide, index) => {
            const el = slide.slide || slide;
            if (el?.getAttribute('data-image-id') == variantImageId) {
                targetIndex = index;
            }
        });
        if (targetIndex !== null) mainSplide.go(targetIndex);
    }
}
// 监听变体切换事件
document.addEventListener('watt:prod:var:changed', function(data) {
    if (data && data.detail) {
        const root = data.detail.root || null
        if(!root.classList.contains('watt-prod')) return
        const selectedVariant = data.detail.selectedVariant || null
        if(!selectedVariant || !root) return
        setBarSelectedVariant(selectedVariant, selectEl) // 设置购买栏选择的变体
        setMainProdImage(selectedVariant, mainSplide) // 设置主图片

        // 1) 更新 URL 里的 ?variant=ID（不会刷新页面）
        let url = new URL(window.location.href);
        url.searchParams.set('variant', String(selectedVariant.id));
        window.history.replaceState({}, '', url.toString());
    }
})

  // description 折叠功能
  function toggleCollapsible() {
    const rootDom = document.querySelector('.watt-prod__desc')
    if (!rootDom) return
    const productContent = rootDom.querySelector('.watt-prod__desc-wrap')
    const viewBtn = rootDom.querySelector('.watt-prod__desc-toggle');
    const toggleText = rootDom.querySelector('.watt-prod__desc-toggle-text');
    const viewMoreText = rootDom.getAttribute('data-view-more')
    const viewLessText = rootDom.getAttribute('data-view-less')
    const pcDfh = rootDom.getAttribute('data-pc-dfh')
    const mDfh = rootDom.getAttribute('data-m-dfh')
    const hasDesc = rootDom.getAttribute('data-has-desc')
    // 检查内容高度是否小于最小高度
    const pcDfhPx = pcDfh * 16; // 与 CSS 中的 max-height 保持一致
    const mDfhPx = mDfh * 8
    let minHeight = window.innerWidth > 900 ? pcDfhPx : mDfhPx
    if (productContent.scrollHeight <= minHeight) {
      // 如果内容不足以触发折叠，就隐藏展开按钮
      viewBtn.style.display = 'none';
      productContent.classList.add('less-limit-height')
      if (!hasDesc) {
        productContent.style.paddingBottom = 0
      }
      return; // 不需要绑定事件
    }
    viewBtn.addEventListener('click', () => {
      const expanded = productContent.classList.toggle('expanded');
      viewBtn.classList.toggle('active', expanded);
      toggleText.textContent = expanded ? viewLessText : viewMoreText;
    });
  }
  toggleCollapsible()

  // coupon code 复制功能
  function copyFn(e) {
    const btn = e.target.closest('.watt-prod__coupon-btn');
    if (!btn) return;
    const codeDom = btn.parentElement.querySelector('.watt-prod__coupon-code-text');
    const copied = btn.getAttribute('data-copied-text')
    const copy = btn.getAttribute('data-copy-text')
    if (!codeDom) return;
    const code = codeDom.textContent.trim();
    navigator.clipboard.writeText(code).then(() => {
      btn.textContent = copied;
      setTimeout(() => {
        btn.textContent = copy;
      }, 1500);
    }).catch(err => {
      console.error('Copy error:', err);
    })
  }
  document.addEventListener('click', function(e) {
    copyFn(e)
  })


  // buybar 显示隐藏功能
  const closeBuybar = root.querySelector('.watt-prod__buybar-close')
  const openBuybar = root.querySelector('.watt-prod__mbuybtn')

  closeBuybar.addEventListener('click', function() {
    buybar.classList.remove('watt-active');
  })
  openBuybar.addEventListener('click', function() {
    buybar.classList.add('watt-active');
  })

  // 点击空白处关闭
  document.addEventListener('click', function(e) {
    if (window.innerWidth >= 900) return
    // buybar 未打开 → 不处理
    if (!buybar.classList.contains('watt-active')) return;

    // 如果点击在 buybar 内部 → 不关闭
    if (buybar.contains(e.target)) return;

    if (openBuybar.contains(e.target)) return;

    // 点击在 buybar 外部 → 关闭
    buybar.classList.remove('watt-active');
  });

  // 滚动监听，控制 buybar btn 显示隐藏
  if (openBuybar && root) {
    const obsBuyBar = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 在视口内 → 移除 active
          openBuybar.classList.remove('watt-active');
        } else {
          // 离开视口 → 添加 active
          openBuybar.classList.add('watt-active');
        }
      });
    }, {
      threshold: 0, // 只要离开一点点视口就触发
    });
    obsBuyBar.observe(root);
  }

  const footerEl = document.querySelector('.watt-footer')
  if (root && buybar) {
    let observer = null;

    function enableObserver() {
      if (observer) return; // 已经启用过了
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            footerEl.classList.remove('watt-active--prod-mg')
            buybar.classList.remove('watt-active');
          } else {
            buybar.classList.add('watt-active');
            footerEl.classList.add('watt-active--prod-mg')
          }
        });
      }, {
        threshold: 0
      });

      observer.observe(root);
    }

    function disableObserver() {
      if (!observer) return; // 已经禁用了
      observer.disconnect();
      observer = null;
    }

    function handleResize() {
      if (window.innerWidth >= 900) {
        enableObserver();
      } else {
        disableObserver();
      }
    }
    // 初始执行
    handleResize();
    // 监听屏幕变化
    window.addEventListener('resize', handleResize);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newslatter"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  function setHideTime(days) {
    const expireAt = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem('watt_newsletter_hide_until', expireAt);
  }

  function isHidden() {
    const until = localStorage.getItem('watt_newsletter_hide_until');
    return until && Number(until) > Date.now();
  }

  const popup = document.querySelector('.watt-newsletter');
  if (!popup) return;

  const delay = Number(popup.dataset.delay) || 0;
  const cookieDays = Number(popup.dataset.cookieDays) || 30;

  const url = window.location.href;
  const justSubscribed = url.includes('customer_posted=true') && url.includes('#watt-newsletter-form');
  const img = popup.querySelector('.watt-newsletter__img')
  const realImgSrc = img ? img.dataset.src : null;

  function loadImage() {
    if (!img || !realImgSrc) return;
    // 如果已经加载过，直接返回
    if (img.src === realImgSrc) return;
    img.src = realImgSrc;
  }

  // 刚订阅成功，立即打开，不延时
  if (justSubscribed && !isHidden()) {
    popup.style.display = 'flex';
    popup.classList.add('show');
    loadImage();
  } else {
    // 正常逻辑
    if (!isHidden()) {
      document.addEventListener('scroll', () => {
        if (window.scrollY > 1) {
          setTimeout(() => {
            popup.style.display = 'flex';
            popup.classList.add('show');
            loadImage();
          }, delay);
        }
      },{ once: true });
    }
  }

  const hideCheckbox = popup.querySelector('#watt-newsletter-hide');

  const closePopup = () => {
    popup.classList.remove('show');
    setTimeout(() => {
      popup.style.display = 'none';
    }, 300);
    if (hideCheckbox && hideCheckbox.checked) {
      setHideTime(cookieDays);
    }
  };

  const closeButton = popup.querySelector('.watt-newsletter__close');
  const overlay = popup.querySelector('.watt-newsletter__overlay');

  if (closeButton) closeButton.onclick = closePopup;
  if (overlay) overlay.onclick = closePopup;

  const form = popup.querySelector('.watt-newsletter__form');
  form.addEventListener('submit', async (e) => {
    // 不要立即关闭弹窗
    // setHideTime(cookieDays);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-block-splide"] && !Shopify.designMode) return;
  try {
    
  function initNormalBlkSplide() {
    const wraps = document.querySelectorAll('.watt-normal__blksplide-wrap');
    if (!wraps.length || !window.wattcycle) return;

    window.wattcycle.loadSplide().then(function () {
      wraps.forEach(function (wrap) {
        const pc_num = wrap.dataset.pcNum || 4;
        const m_num = wrap.dataset.mNum || 2;

        function mountPanel(panel) {
          if (!panel) return;
          const splideEl = panel.querySelector('.watt-normal__blksplide-splide');
          if (!splideEl || splideEl._wattBlkSplide) return;

          const listDom = splideEl.querySelector('.watt-normal__blksplide-list');
          let isPCNoSplide = false;
          if (listDom && listDom.dataset && listDom.dataset.noSplide === 'true') {
            isPCNoSplide = true;
          }

          const splide = new Splide(splideEl, {
            pagination: true,
            arrows: true,
            drag: true,
            snap: true,
            cover: true,
            perPage: pc_num,
            resetProgress: false,
            gap: '1em',
            lazyLoad: 'nearby',
            destroy: isPCNoSplide,
            breakpoints: {
              900: {
                perPage: m_num,
                gap: '2em',
                destroy: false,
              },
            },
            classes: {
              page: 'watt-normal__blksplide-pgn-item',
            },
          });
          splide.mount();
          splideEl._wattBlkSplide = splide;
        }

        const tabs = wrap.querySelectorAll('[data-watt-blksplide-tab]');
        const panels = wrap.querySelectorAll('.watt-normal__blksplide-panel');

        // 挂载当前激活面板
        const activePanel = wrap.querySelector('.watt-normal__blksplide-panel.is-active') || panels[0];
        mountPanel(activePanel);

        // tab 切换
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            const tabName = tab.dataset.wattBlksplideTab;

            tabs.forEach(function (item) {
              const isActive = item === tab;
              item.classList.toggle('is-active', isActive);
              item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            panels.forEach(function (panel) {
              const isActive = panel.dataset.wattBlksplidePanel === tabName;
              panel.classList.toggle('is-active', isActive);

              if (isActive) {
                mountPanel(panel);
                const splideEl = panel.querySelector('.watt-normal__blksplide-splide');
                if (splideEl && splideEl._wattBlkSplide) {
                  window.requestAnimationFrame(function () {
                    splideEl._wattBlkSplide.refresh();
                  });
                }
              }
            });
          });
        });

        // 视频点击, 弹窗播放
        wrap.addEventListener('click', function (e) {
          const trigger = e.target.closest('.watt-normal__blksplide-video-trigger');
          if (!trigger || !wrap.contains(trigger)) return;
          e.preventDefault();
          const item = trigger.closest('.watt-normal__blksplide-item');
          if (!item) return;
          const template = item.querySelector('template[data-blksplide-video]');
          if (!template || !window.wattcycle_modal) return;
          const domNode = template.content.cloneNode(true);
          window.wattcycle_modal.open(domNode);
        });
      });
    });
  }
  window.addEventListener('DOMContentLoaded', initNormalBlkSplide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-faq-section"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function () {
  if (!window.wattcycle) return
  window.wattcycle.accordion('.watt-normal__faq-btn')
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-img-splide"] && !Shopify.designMode) return;
  try {
    
  function initSplide() {
    const splideEl = document.querySelectorAll('.watt-normal__imgsplide-wrap')
    if(!splideEl) return
    if (window.wattcycle) {
      window.wattcycle.loadSplide().then(function () {
        splideEl.forEach(function(item) {
          const splideItem = item.querySelector('.watt-normal__imgsplide-splide')
          if(splideItem) {
            var pc_num = item.dataset.pcNum || 4;
            var m_num = item.dataset.mNum || 2;
            var splide = new Splide(splideItem, {
              pagination: true,
              arrows: true,
              type: 'loop',
              drag: true,
              snap: true,
              cover: true,
              perPage: pc_num,
              autoplay: true,
              resetProgress: false,
              gap: '1.40625em',
              lazyLoad: 'nearby',
              breakpoints: {
                900: {
                  perPage: m_num,
                  gap: '1.875em',
                },
              },
              classes: {
                page: 'watt-normal__imgsplide-pgn-item',
              },
            });
            window.wattcycle.setSplideProgress(splide);
            splide.mount();
          }
        })
      });
    }
  }
  window.addEventListener('DOMContentLoaded', initSplide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-section"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function () {
    const playersMap = new Map();
    let isApiLoading = false;
    let isApiReady = false;
    let apiResolveQueue = [];

    function loadYoutubeAPI() {
        return new Promise((resolve) => {
            if (isApiReady) return resolve();
            if (isApiLoading) return apiResolveQueue.push(resolve);

            isApiLoading = true;

            window.onYouTubeIframeAPIReady = function () {
                isApiReady = true;
                isApiLoading = false;
                resolve();
                apiResolveQueue.forEach(cb => cb());
                apiResolveQueue = [];
            };

            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(tag);
        });
    }

    document.addEventListener('click', async function (e) {
        const trigger = e.target.closest('.watt-normal__youtube-trigger');
        if (!trigger) return;

        const container = trigger.closest('.watt-normal__youtube');
        const iframe = container.querySelector('.watt-normal__youtube-iframe');
        const loader = container.querySelector('.watt-normal__youtube-loading');
        const cover = container.querySelector('.watt-normal__youtube-cover');
        const icon = container.querySelector('.watt-normal__youtube-icon');

        if (!iframe) return;

        // 避免重复点击
        if (container.classList.contains('watt-normal__youtube-isloading')) return;

        // 显示加载动画
        container.classList.add('watt-normal__youtube-isloading');
        loader.style.display = 'flex';

        // 点击后立即隐藏封面和按钮（不再恢复）
        cover.style.opacity = '0';
        icon.style.opacity = '0';
        cover.style.pointerEvents = 'none';
        icon.style.pointerEvents = 'none';

        await loadYoutubeAPI();

        let player = playersMap.get(iframe);

        if (!player) {
            const videoId = iframe.dataset.videoId;
            iframe.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&origin=${location.origin}`;

            player = new YT.Player(iframe, {
                events: {
                    onReady: (event) => event.target.playVideo(),
                    onStateChange: (event) => handlePlayerStateChange(event, container)
                }
            });

            playersMap.set(iframe, player);
        } else {
            player.playVideo();
        }


    });

    function handlePlayerStateChange(event, container) {
        const loader = container.querySelector('.watt-normal__youtube-loading');
        if (event.data === YT.PlayerState.PLAYING) {
            // 播放开始 → 隐藏 loading
            container.classList.remove('watt-normal__youtube-isloading');
            loader.style.display = 'none';
            // 互斥播放
            playersMap.forEach((otherPlayer, otherIframe) => {
                if (otherIframe !== event.target.getIframe()) {
                    if (otherPlayer.getPlayerState() === YT.PlayerState.PLAYING) {
                        otherPlayer.pauseVideo();
                    }
                }
            });
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-tab-product"] && !Shopify.designMode) return;
  try {
    
function initNormalTabProduct() {
    const sections = document.querySelectorAll('.watt-normal__tabprod-wrap');
    if (!sections.length || !window.wattcycle) return;

    window.wattcycle.loadSplide().then(function () {
        sections.forEach(function (section) {
            function mountPanel(panel) {
                const splideEl = panel.querySelector('.watt-normal__tabprod-splide');
                if (!splideEl || splideEl._wattTabProdSplide) return;

                splideEl._wattTabProdSplide = new Splide(splideEl, {
                    pagination: true,
                    arrows: true,
                    type: 'slide',
                    drag: 'free',
                    perPage: 3,
                    breakpoints: {
                        900: {
                            perPage: 1,
                        },
                    },
                    classes: {
                        page: 'watt-normal__tabprod-pgn-item',
                    },
                });

                splideEl._wattTabProdSplide.mount();
            }

            const tabs = section.querySelectorAll('[data-watt-tabprod-tab]');
            const panels = section.querySelectorAll('[data-watt-tabprod-panel]');
            const activePanel = section.querySelector('.watt-normal__tabprod-panel.is-active');

            if (activePanel) mountPanel(activePanel);

            tabs.forEach(function (tab) {
                tab.addEventListener('click', function () {
                    const tabName = tab.dataset.wattTabprodTab;

                    tabs.forEach(function (item) {
                        const isActive = item === tab;
                        item.classList.toggle('is-active', isActive);
                        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    });

                    panels.forEach(function (panel) {
                        const isActive = panel.dataset.wattTabprodPanel === tabName;
                        panel.classList.toggle('is-active', isActive);

                        if (isActive) {
                            mountPanel(panel);
                            const splideEl = panel.querySelector('.watt-normal__tabprod-splide');
                            if (splideEl && splideEl._wattTabProdSplide) {
                                window.requestAnimationFrame(function () {
                                    splideEl._wattTabProdSplide.refresh();
                                });
                            }
                        }
                    });
                });
            });
        });
    });
}

window.addEventListener('DOMContentLoaded', initNormalTabProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-video-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.watt-lazy-video');
    const screenWidth = window.innerWidth;
    // 根据屏幕宽度选择视频源
    function getVideoSrc(sourceEl) {
        if (screenWidth > 900) {
            return sourceEl.dataset.pcSrc;
        } else {
            return sourceEl.dataset.mSrc || sourceEl.dataset.pcSrc;
        }
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target;
                const source = video.querySelector('source');
                const ctr = video.closest('.watt-normal__videobanner-wrap');
                const coverImg = ctr?.querySelector('.watt-normal__videobanner-cover');
                // 选择正确的视频源
                const selectedSrc = getVideoSrc(source);
                // 懒加载：只有进入视口才设置 src
                if (selectedSrc && source.src !== selectedSrc) {
                    source.src = selectedSrc;
                    video.load();
                }
                video.play().catch(() => {});
                video.addEventListener('loadeddata', () => {
                    if (coverImg) coverImg.style.opacity = '0';
                });
                observer.unobserve(video);
            }
        });
    }, {
        rootMargin: '200px 0px',
        threshold: 0.1
    });
    videos.forEach(video => observer.observe(video));
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["normal-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.watt-normal__video-wrap');

  if (!containers.length) return;

  containers.forEach((container) => {
    const toggleButton = container.querySelector('.watt-normal__video-toggle');
    const template = container.querySelector('template[data-video-template]');

    if (!toggleButton || !template) return;

    const mountVideo = () => {
      const instantiate = () => {
        const clone = template.content.cloneNode(true);
        toggleButton.replaceWith(clone);
      };

      if (document.startViewTransition) {
        document.startViewTransition(instantiate);
      } else {
        instantiate();
      }
    };

    toggleButton.addEventListener('click', mountVideo, { once: true });
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prod-tab-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  if (!window.wattcycle) return;

  const tabSection = document.querySelector('.watt-prodtab');
  const tabWrap = document.querySelector('.watt-prodtab__wrap');

  // 1. 吸顶逻辑（保持不变，只是封装了一下）
  if (tabSection && tabWrap) {
    let sectionTop = tabSection.offsetTop;

    function handleSticky() {
      const scrollY = window.scrollY || window.pageYOffset;
      if (scrollY >= sectionTop) {
        tabWrap.classList.add('watt-active');
      } else {
        tabWrap.classList.remove('watt-active');
      }
    }

    const throttledSticky = window.wattcycle.throttle(handleSticky, 50);
    window.addEventListener('scroll', throttledSticky);
    window.addEventListener('resize', window.wattcycle.throttle(() => {
      sectionTop = tabSection.offsetTop;
      handleSticky();
    }, 500));

    throttledSticky();
  }

  // 2. 动态 Tab 激活逻辑（完全不写死 ID）
  const btnActiveName = 'watt-active';
  const tabButtons = Array.from(document.querySelectorAll('.watt-prodtab__btn[data-watt-tab-target]'));

  let sections = [];

  function computeSections() {
    sections = [];

    tabButtons.forEach((btn) => {
      const href = btn.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      const id = href.slice(1);
      if (!id) return;

      const targetEl = document.getElementById(id);

      // 如果目标 section 不存在，隐藏对应的 li
      if (!targetEl) {
        const parentLi = btn.closest('.watt-prodtab__item');
        if (parentLi) parentLi.style.display = 'none';
        return;
      }

      // 确保存在时显示
      const parentLi = btn.closest('.watt-prodtab__item');
      if (parentLi) parentLi.style.display = '';

      sections.push({
        btn: btn,
        el: targetEl,
        start: targetEl.offsetTop
      });
    });

    // 按页面顺序排序
    sections.sort((a, b) => a.start - b.start);

    // 生成区间 [start, end)
    for (let i = 0; i < sections.length; i++) {
      const current = sections[i];
      const next = sections[i + 1];
      current.start = current.el.offsetTop;
      current.end = next ? next.el.offsetTop : Infinity;
    }
  }

  computeSections();

  window.addEventListener('resize', window.wattcycle.throttle(() => {
    computeSections();
    tabHandleScroll();
  }, 500));

  function tabHandleScroll() {
    const scrollY = (window.scrollY || window.pageYOffset) + 60;

    tabButtons.forEach((btn) => btn.classList.remove(btnActiveName));

    const current = sections.find((item) => scrollY >= item.start && scrollY < item.end);
    if (current && current.btn) {
      current.btn.classList.add(btnActiveName);
    }
  }

  const throttledTabScroll = window.wattcycle.throttle(tabHandleScroll, 300);
  window.addEventListener('scroll', throttledTabScroll);
  throttledTabScroll();

  // 3. 监听 section 高度变化，动态更新区间
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => {
      computeSections();
      tabHandleScroll();
    });

    tabButtons.forEach((btn) => {
      const href = btn.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      const id = href.slice(1);
      if (!id) return;

      const targetEl = document.getElementById(id);
      if (targetEl) ro.observe(targetEl);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
